import {
    ajax,
    ajaxP,
    ajaxB
} from '@/utils/request'

// 代步车订单列表
export function orderList(params) {
    return ajaxB('api/v1/rentCar/orders/h5/page', params)
}
// 代步车订单详情
export function orderInfo(id) {
    return ajax(`api/v1/rentCar/orders/h5/${id}`)
}
// 代步车取消订单
export function changeOrder(id) {
    return ajaxP(`api/v1/rentCar/orders/h5/cancel/${id}`, null, true)
}
// 代步车门店地址
export function addressList(num) {
    return ajax('api/v1/rentCar/orders/h5/shop/list', {
        province: "内蒙古自治区"
    })
}

// 代步车用户权限
export function scooterVip() {
    return ajax('api/v1/elecTickets/h5/rentCar/right')
}

// 代步券列表
export function voucherList() {
    return ajax('api/v1/elecTickets/h5/list/rentCar/effective')
}

// 创建代步车订单
export function scooterAdd(params) {
    return ajaxP('api/v1/rentCar/orders/h5', params)
}